// Shared micro-utilities for the script domain modules.
// Promoted here so script-core's split modules (selector / validate / patch /
// ids / …) and the usecase layer share one copy instead of each redefining
// these generic JSON guards.

import { CliError, EXIT_USAGE } from "../../common.js";

export type Dict = Record<string, unknown>;

export function strOf(v: unknown): string {
  if (v === null || v === undefined) return "";
  return String(v);
}

export function isDict(v: unknown): v is Record<string, unknown> {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}

export function isList(v: unknown): v is unknown[] {
  return Array.isArray(v);
}

export function asList<T = unknown>(v: unknown): T[] {
  return Array.isArray(v) ? (v as T[]) : [];
}

// Parse the numeric tail of an id like `ep_007` / `scn_012` (→ 7 / 12).
// Returns NaN when the id does not match `${prefix}_<digits>`.
export function idNum(id: string, prefix: string): number {
  const m = new RegExp(`^${prefix}_(\\d+)$`).exec(strOf(id).trim());
  return m ? parseInt(m[1]!, 10) : NaN;
}

// Error factory used throughout the patch op engine. Defaults to EXIT_USAGE.
export function opErr(
  title: string,
  message: string,
  opts: {
    exitCode?: number;
    required?: string[];
    received?: string[];
    nextSteps?: string[];
    op?: string;
    errorCode?: string;
  } = {},
): CliError {
  return new CliError(message, {
    exitCode: opts.exitCode ?? EXIT_USAGE,
    errorCode: opts.errorCode ?? title.replace(/[^A-Za-z0-9]+/g, "_").replace(/^_|_$/g, "").toUpperCase(),
    hint: opts.nextSteps?.[0],
    data: { expected: opts.required, actual: opts.received, op: opts.op },
  });
}
